import { Divider } from "@gluestack-ui/themed";
import { ParametersAccordionProps } from "./types";
import { AccordionContainer } from "@repo/core/components/layout/ProposalAccordion/components/AccordionContainer";

import { ProposalProductSection } from "@repo/core/components/layout/ProposalProductSection";
import { ProposalFinancialServicesSection } from "@repo/core/components/layout/ProposalFinancialServicesSection";
import { InputTypeSelect } from "@repo/core/components/forms/InputTypeSelect";
import { MustShow } from "@repo/core/components/core/MustShow";
import {
  ProposalTypeEnum,
  proposalTypeOptions
} from "@repo/core/screens/ProposalEffectiveFlows/Credit/DetailsCreditProposal/consts";

export const ParametersAccordion = ({
  dueDatesOptions,
  selectedInputType,
  productCardNumber,
  productDescription,
  productName,
  proposalName,
  proposalType,
  proposalValue,
  ...rest
}: ParametersAccordionProps) => {
  return (
    <AccordionContainer {...rest}>
      <ProposalProductSection
        name={productName}
        description={productDescription}
        cardNumber={productCardNumber}
        isShowEditButton={false}
      />
      <Divider />
      <ProposalFinancialServicesSection
        name={proposalName}
        value={proposalValue}
        isShowEditButton={false}
      />
      <Divider />
      <MustShow
        isVisible={
          proposalType !== proposalTypeOptions[ProposalTypeEnum.FIDELITY]
        }
      >
        <InputTypeSelect
          inputTypes={dueDatesOptions}
          widthFull
          isClickable={false}
          selectedInputType={selectedInputType}
          label="Dia do mês do vencimento da fatura:"
        />
      </MustShow>
    </AccordionContainer>
  );
};
